import Layout from '../Layout';

const Dashboard = () => {
  return (
    <Layout>
      <h1 className="text-2xl font-semibold"> Dashboard Coming Soon...</h1>
      <h4
        className="text-1xl font-semibold"
        style={{ color: 'red', opacity: '0.8' }}
      >
        Sample data representation. Please go to the patient's section
      </h4>
      <div
        className="mb-4 flex flex-col"
        style={{ backgroundColor: 'white' }}
      ></div>
    </Layout>
  );
};

export default Dashboard;
